module.exports = __webpack_public_path__ + "static/p14_back-48acb46b4bbcc7eee286513b754687cb.jpg";